"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImmer = exports.setImmer = void 0;
var tslib_1 = require("tslib");
var defaultImmerModule = tslib_1.__importStar(require("immer"));
var immerModule;
function setImmer(newImmer) {
    immerModule = newImmer;
    newImmer.enablePatches();
    // This causes issues when assigning objects to themselves
    //  const state = {
    //      foo: { bar: 123 },
    //  }
    //
    //  <Field name='foo' component={input => input.onChange(input.value)} />
    //
    // In that example, state.foo will be frozen and all FormEvents will receive it as a frozen object
    //  instead of a draft
    newImmer.setAutoFreeze(false);
}
exports.setImmer = setImmer;
function getImmer() { return immerModule; }
exports.getImmer = getImmer;
setImmer(defaultImmerModule);
exports.default = getImmer;
//# sourceMappingURL=getImmer.js.map